export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produit"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "internet_tv_offer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offre internet et/ou TV"])},
        "line_holder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Titulaire de la ligne"])},
        "contract_reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Référence contrat"])},
        "subscription_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de souscription"])},
        "product_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Titre"])},
        "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Référence"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "internet_tv_offer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internet and/or TV offer"])},
        "line_holder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Line holder"])},
        "contract_reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contract reference"])},
        "subscription_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subscription date"])},
        "product_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
        "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reference"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price"])}
      }
    }
  })
}
